module.exports = __webpack_public_path__ + "static/media/slide_one.84753208.jpg";